// src/components/placement/TimerBar.jsx
import React from 'react';

export default function TimerBar({ timeLeft, totalSeconds = 30 }) {
  const pct     = (timeLeft / totalSeconds) * 100;
  const isUrgent  = timeLeft <= 10;
  const isCritical = timeLeft <= 5;

  const barColor = isCritical
    ? 'bg-red-500'
    : isUrgent
    ? 'bg-orange-400'
    : 'bg-emerald-500';

  const textColor = isCritical
    ? 'text-red-600'
    : isUrgent
    ? 'text-orange-500'
    : 'text-emerald-600';

  return (
    <div className="w-full space-y-1">
      {/* Número de segundos */}
      <div className="flex justify-between items-center">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          Tiempo
        </span>
        <span className={`text-sm font-black tabular-nums transition-colors ${textColor} ${isCritical ? 'animate-pulse' : ''}`}>
          {timeLeft}s
        </span>
      </div>

      {/* Barra */}
      <div className="w-full h-2.5 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-1000 ease-linear ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* Mensaje de urgencia */}
      {isCritical && (
        <p className="text-[10px] text-red-500 font-black text-right animate-pulse">
          ⚡ ¡Responde ya!
        </p>
      )}
    </div>
  );
}
